import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden bg-foreground-950 p-10 md:p-14 text-center">
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">
              准备建立合规运营体系？
            </h2>
            <p className="text-foreground-400 max-w-lg mx-auto mb-8 text-sm leading-relaxed">
              浏览我们的分类指南，从法律合规到技术架构，获取全面的行业知识与实操建议。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/legal-compliance"
                className="px-7 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
              >
                探索合规指南
              </Link>
              <Link
                to="/about"
                className="px-7 py-3 border border-background-50/20 text-background-50 rounded-lg font-medium text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors duration-200"
              >
                了解更多
              </Link>
            </div>
          </div>
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/10 rounded-full -translate-y-1/2 translate-x-1/3 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/10 rounded-full translate-y-1/2 -translate-x-1/3 blur-3xl"></div>
        </div>
      </div>
    </section>
  );
}